import { Box } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useUser } from '@/hooks/useUser';

export const NoPaymentMethodsAvailableDialog = () => {
  const navigate = useNavigate();
  const { isUserAgent } = useUser();

  const goHome = () => {
    navigate('/');
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={true}
      setOpened={() => {}}
      buttons={
        <StandardButton main onClick={goHome}>
          <Text tId={'BACK_TO_HOME'} />
        </StandardButton>
      }
    >
      <Box mb={4}>
        <Font variant={'h3'} color={'title'}>
          <Text tId={'NOT_POSSIBLE_CREATING_NEW_APPLICATION'} />
        </Font>
      </Box>
      <Box mb={2}>
        <Font variant={'body2'} color={'textPrimary'}>
          <Text
            tId={
              isUserAgent ? 'NO_PAYMENT_METHODS_AVAILABLE_FOR_USER' : 'NO_PAYMENT_METHODS_AVAILABLE_FOR_SELECTED_AGENT'
            }
          />
        </Font>
      </Box>
      <Box mb={2}>
        <Font variant={'body2'} color={'textPrimary'}>
          <Text tId={'CONTACT_NEMURU_FOR_SERVICE_ACTIVATION_OR_ERROR'} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
